module.exports = __webpack_public_path__ + "static/media/25.57b81054.png";